import React from 'react';
import {Link} from 'react-router-dom'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'
import {openModal, closeModal, toggleState} from 'Skelet/src/modules/functions.js'
import ModalPoll from './ModalPoll.js'
import ModalCreatePoll from './ModalCreatePoll.js'
import ModalSearchPolls from './ModalSearchPolls.js'
import {time_ago_human} from 'Skelet/src/modules/time_ago.js'
import refresh_icon from '../images/refresh-icon.svg';


class QuickPolls extends React.Component {

  constructor(props) {
    super(props);
    this.state = {page:0, modal_open:false, modal_content:{}, modal_create_open:false, modal_search_open:false, search_param:""};
  }

  componentWillMount() {
    if(this.props.session_token) {
      let sp = (this.state.search_param !== "") ? "&search="+this.state.search_param : "";
      this.props.fetchDataIfReady(config.api_token, "quickpoll-index", "GET", config.api_url+"/poll-index?t="+this.props.session_token+"&type=qp"+sp, undefined, {"PM-List-Page":this.state.page});
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      let sp = (this.state.search_param !== "") ? "&search="+this.state.search_param : "";
      this.props.fetchDataIfUndefined(config.api_token, "quickpoll-index", "GET", config.api_url+"/poll-index?t="+nextProps.session_token+"&type=qp"+sp);
    }
  }

  render() {
    const {account_plan} = this.props;
    let cards = "", end_of_list_text = "", page_cards = this.props.apiData["quickpoll-index"];
    if(page_cards !== undefined) {
      cards = page_cards.data.map(function(item, i) {
        item.i = i;
        let created_at = new Date(item.created_at);
        let timestamp = created_at.toLocaleString();
        item.timestamp = timestamp;
        let today = new Date();
        let now = new Date();
        today.setHours(0,0,0,0);
        if(today.getTime() < created_at.getTime()) { // if created_at is today, display only the time
          timestamp = created_at.toLocaleTimeString();
        }

        let time_ago = (now.getTime() - created_at.getTime()) / 1000 / 60; // minutes
        let time_ago_txt = time_ago_human(time_ago);
        item.time_ago_txt = time_ago_txt;

        return <div key={i}>
          <small style={{marginTop:"2em", marginBottom:"10px", opacity:".5", display:"block", fontSize:"75%", textAlign:"right"}}>{this.props.i18n_texts["gen_created"][this.props.app_language]} {item.time_ago_txt} | {item.vote_count} {this.props.i18n_texts["gen_votes"][this.props.app_language]}</small>
          <div className="card polls card-layout">
            <div className="card-layout-div85">{item.name}</div>
            <div className="card-layout-div15 btn-detail"><Link to="/" className="btn" onClick={(e) => openModal(this, e, item)}>{this.props.i18n_texts["gen_view"][this.props.app_language]}</Link></div>
          </div>
        </div>;
      }.bind(this));
    }

    if(page_cards === undefined || page_cards.isFetching) {
      end_of_list_text = this.props.i18n_texts["core_polls_loading"][this.props.app_language];
    } else if((page_cards !== undefined && !page_cards.isFetching && page_cards.limitReached)) {
      if(page_cards.data[0] !== undefined) {
        end_of_list_text = this.props.i18n_texts["core_quickpolls_eol_new"][this.props.app_language]; // End of results.
      } else {
        end_of_list_text = this.props.i18n_texts["core_quickpolls_eol_first"][this.props.app_language]; // No results.
      }
    }

    return (
      <div className="container content">
        {this.state.show_thanks && <div className="thanks" onClick={(e) => toggleState(this, "show_thanks")}>{this.props.i18n_texts["core_polls_thanks"][this.props.app_language]} <span dangerouslySetInnerHTML={{__html:this.props.i18n_texts["pricing_contact"][this.props.app_language]}}></span></div>}
        <div className="card-layout">
          <div className="card-layout-div50"><strong>{this.props.i18n_texts["core_quickpolls_title"][this.props.app_language]}</strong></div>
          <div className="card-layout-div50 index-actions">
            <button className={this.state.search_param === "" ? "btn" : "btn btn-b"} style={{marginRight:"10px"}} onClick={() => openModal(this, null, null, "modal_search_open")}>{this.props.i18n_texts["gen_search"][this.props.app_language]}</button>
            {((account_plan === "premium" || account_plan === "trial") && page_cards !== undefined) && <button className="btn" style={{marginRight:"10px"}} onClick={() => openModal(this, null, null, "modal_create_open")}>{this.props.i18n_texts["core_polls_create"][this.props.app_language]}</button>}
            {(account_plan === "lite" && page_cards !== undefined && page_cards.data[0] === undefined) && <button className="btn" style={{marginRight:"10px"}} onClick={() => openModal(this, null, null, "modal_create_open")}>{this.props.i18n_texts["core_polls_create"][this.props.app_language]}</button>}
            {(account_plan === "lite" && page_cards !== undefined && page_cards.data[0] !== undefined) && <button className="btn" style={{marginRight:"10px"}}><span role="img" aria-label="lock">🔒</span> {this.props.i18n_texts["core_polls_create"][this.props.app_language]}</button>}
            <img src={refresh_icon} alt={this.props.i18n_texts["core_polls_refresh"][this.props.app_language]} onClick={() => this.refresh()}/>
          </div>
        </div>
        {cards}
        <div className="end_of_list_text">{end_of_list_text}</div>
        <ModalPoll shouldShow={this.state.modal_open} close={() => closeModal(this)} content={this.state.modal_content} type="qp" account_plan={account_plan} i18n_texts={this.props.i18n_texts} app_language={this.props.app_language} />
        <ModalCreatePoll shouldShow={this.state.modal_create_open} close={() => closeModal(this, "modal_create_open")} type="qp" i18n_texts={this.props.i18n_texts} app_language={this.props.app_language} />
        <ModalSearchPolls shouldShow={this.state.modal_search_open} close={() => closeModal(this, "modal_search_open")} setParentSearch={(search_param) => {this.setState({search_param});setTimeout(function(){this.refresh()}.bind(this), 0)}} i18n_texts={this.props.i18n_texts} app_language={this.props.app_language} />
      </div>
    );
  }

  refresh() {
    this.props.clearStateBlock("quickpoll-index");
  }

}


function mapStateToProps(state) {
  let session_token = null, account_plan = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  if(state.apiData["plan"] !== undefined && state.apiData["plan"]["data"]["name"] !== undefined) {
    account_plan = state.apiData["plan"]["data"]["name"];
    if(state.apiData["login"] !== undefined && state.apiData["login"]["data"]["email"] !== undefined && state.apiData["login"]["data"]["email"] === "hi@peter.plus") {
      account_plan = "premium";
    }
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
    account_plan: account_plan,
    location: state.router.location,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(QuickPolls)



// WEBPACK FOOTER //
// ./src/containers/QuickPolls.js